import { Provider } from '@react-spectrum/s2'
import '@react-spectrum/s2/page.css'

export function SpectrumAppProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return <Provider background="base">{children}</Provider>
}
